import { Bitmap, ButtonBase, Container, delayedCall, dispatcher, ingenuity, killDelayedCall, Quadratic, SpineBase } from "@quest/base-core";
import { investigationRoomView } from "./InvestigationRoomView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { ButtonBaseBehavior, MeterBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther";
import { ITween } from "@quest/adapter-interface";
import { Linear } from "@quest/pixi-bridge";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { GameParserModel } from "../Platform/GameParserModel";

export class InvestigationRoomController {
  private view: investigationRoomView;
  private closeButton: ButtonBase;
  private grandJPWinMtr: MeterBehavior;
  private clueWinMtr: MeterBehavior;
  private suspectContainer: Container;
  private frameGlow: SpineBase;
  private frameGlowBG: SpineBase;
  private clueInfo: any;
  private category: any = {
    "symbol51": "criminal",
    "symbol52": "location",
    "symbol53": "weapon"
  };
  private suspectArray = ['K', 'L', 'M', 'N', 'O']


  constructor(view: investigationRoomView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvents();
    this.view.visible = false;
  }

  private initializeElements(): void {
    this.suspectContainer = this.view.getContainerByID('suspectContainer');
    this.closeButton = this.view.getButtonById("closeButton") as ButtonBase;
    this.grandJPWinMtr = this.view.getMeterById('grandJPWinMtr') as MeterBehavior;
    this.clueWinMtr = this.view.getMeterById('clueWinMtr') as MeterBehavior;
  }

  private subscribeEvents(): void {
    this.unsubscribeEvents();
    this.handleCloseButton();
    dispatcher.on(eventDispatchers.SHOW_INVESTINGATION_ROOM, this.showInvestigationRoom, this);
    dispatcher.on(eventDispatchers.HIDE_INVESTINGATION_ROOM, this.hideInvestigationRoom, this);
    dispatcher.on(eventDispatchers.START_SUSPECT_REVEAL, this.onStartSuspectReveal, this)
    dispatcher.on(eventDispatchers.DISABLE_BOARD_BUTTONS, this.disableBoardButtons, this);
    dispatcher.on(eventDispatchers.START_CLUE_REVEAL, this.onstartRevelClue, this)
    dispatcher.on(eventDispatchers.SHOW_ROOM_AFTER_BANNER, this.showInvestigationRoomAfterBanner, this)
    dispatcher.on(eventDispatchers.RESET_ROOM_AFTER_GRAND, this.resetRoomAfterGrand, this)
  }
  private unsubscribeEvents(): void {
    this.closeButton.off(ButtonBaseBehavior.UP, this.hideInvestigationRoom, this);
    dispatcher.off(eventDispatchers.SHOW_INVESTINGATION_ROOM, this.showInvestigationRoom, this);
    dispatcher.off(eventDispatchers.HIDE_INVESTINGATION_ROOM, this.hideInvestigationRoom, this);
    dispatcher.off(eventDispatchers.DISABLE_BOARD_BUTTONS, this.disableBoardButtons, this);
    dispatcher.off(eventDispatchers.START_CLUE_REVEAL, this.onstartRevelClue, this)
    dispatcher.off(eventDispatchers.SHOW_ROOM_AFTER_BANNER, this.showInvestigationRoomAfterBanner, this)
    dispatcher.off(eventDispatchers.RESET_ROOM_AFTER_GRAND, this.resetRoomAfterGrand, this)
  }

  private onStartSuspectReveal(): void {
    
      let soundObj = { id: SoundConstantGame.ALL_CLUE_REVEALED, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD };
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
    this.frameGlow = this.view.getSpineById('frameGlow');
    let questionFrame = this.view.getImageById('QuestionFrame');
    const randomLetter = this.suspectArray[Math.floor(Math.random() * this.suspectArray.length)]; //get random suspect
    let suspectPicked = this.view.getImageById(`suspectFrame_${randomLetter}`);
    this.frameGlowBG = this.view.getSpineById('frameGlowBG');

    this.frameGlowBG.setPause(false);
    this.frameGlow.visible = true;
    this.frameGlow.playAnim('revealed_suspects_base_top_effect_in');
    let rotationTween = ingenuity.currentGame.add.tween(questionFrame).to({ rotation: Math.PI * 10 }, SlotConstantsBehavior.DURATION_1000, Quadratic.InOut, true, 0, -1, false);
    this.frameGlow.onComplete.addOnce(() => {
      this.frameGlowBG.visible = true;
      this.frameGlowBG.playAnim('revealed_suspects_base_back_effect_in', true);
    });

    delayedCall('startZooming', SlotConstantsBehavior.DURATION_1200, () => {
      killDelayedCall('startZooming');
      this.zoomOutContainer(suspectPicked, rotationTween)
    })

  }

  private zoomOutContainer(suspectPicked: Bitmap, rotationTween: ITween): void {
    let zoomOut = ingenuity.currentGame.add.tween(this.suspectContainer.scale).to({ x: 0.9, y: 0.9 }, SlotConstantsBehavior.DURATION_500, Linear.None, true, 0, 0, false);
    zoomOut.onComplete.addOnce(() => {
      zoomOut.stop();
      rotationTween.stop();
      this.view.getImageById('QuestionFrame').rotation = 0;
      ingenuity.currentGame.tweens.remove(rotationTween);
      ingenuity.currentGame.tweens.remove(zoomOut);
      this.frameGlowBG.playAnim('revealed_suspects_base_top_effect_loop', true);
      suspectPicked.visible = true;
      suspectPicked.alpha = 0;
      this.showSuspectWithAlpha(suspectPicked);
    });
    delayedCall('showSus', SlotConstantsBehavior.DURATION_500, () => {
      killDelayedCall('showSus')
      this.zoomInContainer()
    })
  }

  private zoomInContainer(): void {
    let zoomIn = ingenuity.currentGame.add.tween(this.suspectContainer.scale).to({ x: 1.2, y: 1.2 }, 800, Linear.None, true, 0, 0, false);
    zoomIn.onComplete.addOnce(() => {
      zoomIn.stop();
      ingenuity.currentGame.tweens.remove(zoomIn);
      let zoomToScale = ingenuity.currentGame.add.tween(this.suspectContainer.scale).to({ x: 1, y: 1 }, 300, Linear.None, true, 0, 0, false);
      zoomToScale.onComplete.addOnce(() => {
        this.frameGlowBG.playAnim('revealed_suspects_base_back_effect_out');
        this.frameGlow.playAnim('revealed_suspects_base_top_effect_out');
        this.frameGlow.onComplete.addOnce(() => {
          this.frameGlow.visible = false;
          this.frameGlowBG.visible = false;
          this.view.visible = false;
          dispatcher.fireEvent(eventDispatchers.SHOW_GRAND_BANNER);
        })
      })
    })
  }
  private showSuspectWithAlpha(suspectPicked: Bitmap): void {
    let alphaTween = ingenuity.currentGame.add.tween(suspectPicked).to({ alpha: 1 }, SlotConstantsBehavior.DURATION_2000, Linear.None, true, 0, 0, false);
    alphaTween.onComplete.addOnce(() => {
      alphaTween.stop();
      ingenuity.currentGame.tweens.remove(alphaTween);
    })
  }

  private showInvestigationRoom(): void {
    this.closeButton.visible = true;
    dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_INVESTIGATION_BLUR_BG);
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, gameConstants.INVESTIGATION_BG_SHOW)
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(eventDispatchers.HIDE_BASEGAME_REEL);
    } else {
      dispatcher.fireEvent(eventDispatchers.HIDE_FREEGAME_REEL);
    }
    ingenuity.configData.showLogoBaseGameScreen = false;
    dispatcher.fireEvent(eventDispatchers.TOP_LOGO_HIDE);
    dispatcher.fireEvent(eventDispatchers.TOP_LOGO_HIDE_ON_BIG_WIN_FG);
    dispatcher.fireEvent(SlotEventConstants.DISABLED_ALL_BUTTONS);
    this.closeButton.enableAndTint();
    this.view.alpha = 0;
    this.view.visible = true;
    //this.stopBasegameSound();
    this.addToTop();
    if ((ingenuity.parserModel as GameParserModel).getPromotionalFreeGame()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_HIDE_PROMOTIONAL_FREE_PLAY, false);
    }
    const fadeInTween: ITween = ingenuity.currentGame.add.tween(this.view);
    fadeInTween.to({ alpha: 1 }, SlotConstantsBehavior.DURATION_500, Linear.None, true, 0, 0, false);
    const smokeAnim = this.view.getSpineById("roomIntroSmoke");
    smokeAnim.playAnim("in_smoke");
    // fadeInTween.onComplete.addOnce(() => {});
    this.showRevealedClue();
    this.showGrandJPValue();
  }

  private addToTop(): void {
    //ingenuity.currentGame.stage.addChild(this.view);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
  }

  protected stopBasegameSound(): void {
    ingenuity.configData.isReelSpinMusicPlaying = false;
    (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD);
    (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    (ingenuity.soundManager as any).stop(SoundConstant.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD);
  }

  private handleCloseButton() {
    this.closeButton.visible = true;
    this.closeButton.on(ButtonBaseBehavior.UP, this.hideRoomAndEnableBasegame, this);
  }
  private disableBoardButtons() {
    this.closeButton.disableAndTint();
  }
  private hideRoomAndEnableBasegame():void{
    this.hideInvestigationRoom();
    dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
  }
  private hideInvestigationRoom(): void {
    SlotConstantsBehavior.FREEGAME_RETURN_SOUND = true;
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.COMMON_CLICK_SOUND, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD });
    // (ingenuity.soundManager as any).stop(SoundConstantGame.BONUS_FEATURE_BG, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    ((ingenuity.parserModel as GameParserModel).getPromotionalFreeGame()) && dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_HIDE_PROMOTIONAL_FREE_PLAY, true);
    ingenuity.configData.showLogoBaseGameScreen = true;
    dispatcher.fireEvent(eventDispatchers.HIDE_POP_UP_BLUR_BG);
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      !ingenuity.deviceEnv.isDsktop && dispatcher.fireEvent(eventDispatchers.TOP_LOGO_SHOW);
      dispatcher.fireEvent(SlotEventConstants.SHOW_BASEGAME_VIEW);
    } else {
      !ingenuity.deviceEnv.isDsktop && dispatcher.fireEvent(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN_FG);
      dispatcher.fireEvent(eventDispatchers.SHOW_FREEGAME_REEL);
    }
    // dispatcher.fireEvent(SlotEventConstants.ENABLED_ALL_BUTTONS);
    this.view.visible = false;
    dispatcher.fireEvent(eventDispatchers.HIDE_INVESTIGATION_BACKGROUND)
    this.clueWinMtr.setValue(0)
    this.clueWinMtr.visible = false;

  }

  private onstartRevelClue(): void {
    let clueRevealed = (ingenuity.parserModel as GameParserModel).getclueRevealedInfo();
    this.showInvestigationRoom();
    this.closeButton.visible = false;
    delayedCall('startTickUp', SlotConstantsBehavior.DURATION_1000, () => {
      killDelayedCall('startTickUp')
      let clueWinAmt = clueRevealed.creditsWon
      if ((ingenuity.parserModel as GameParserModel).getIsGrandJPAvailable()) {
        clueWinAmt = clueWinAmt - (ingenuity.parserModel as GameParserModel).getIsGrandJPPrize()
      }
      this.startMeterTickup(clueWinAmt, clueRevealed.grandPrize);
    });
    delayedCall('startPresentation', SlotConstantsBehavior.DURATION_1200, () => {
      killDelayedCall('startPresentation')
      this.zoomDownUnreveledClue(this.category[clueRevealed.pickedClue], clueRevealed.selectedClue);
      delayedCall('showBannerMsg', 2000, () => {
        killDelayedCall('showBannerMsg')
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
      });

    })
  }
  private startMeterTickup(clueReward: number, grandReward: number): void {
    this.clueWinMtr.visible = true;
    setTimeout(() => {
      this.clueWinMtr.startTick(clueReward, true, false, 0.8, true, () => {
        this.grandJPWinMtr.visible = true;
        this.grandJPWinMtr.startTick(grandReward, true, false, 0.8, true, () => {
        });
      })
    }, 1);
  }
  protected revealClue(category: string, categoryCount: string): void {
    this.playSound();
    const revealGlow: SpineBase = this.view.getSpineById(`${category}Glow_${categoryCount}`);
    switch (category) {
      case "criminal":
        revealGlow.playAnim("reveal_effect_pink", false);
        break;
      case "location":
        revealGlow.playAnim("reveal_effect_sky", false);
        break;
      case "weapon":
        revealGlow.playAnim("reveal_effect_yellow", false);
        break;
    }
    delayedCall('showClue', SlotConstantsBehavior.DURATION_200, () => {
      killDelayedCall('showClue');
      this.showClue(category, categoryCount);
    })
    revealGlow.onComplete.addOnce(() => {
      revealGlow.visible = false;
    }, this);
  }

  private zoomDownUnreveledClue(category: string, categoryCount: string): void {
    let clue = this.view.getImageById(`${category}Unrevealed_${categoryCount}`);
    let tweenscale = ingenuity.currentGame.add.tween(clue.scale).to({ x: 0.3, y: 0.3 }, SlotConstantsBehavior.DURATION_400, Linear.None, true, 100, 0, false);
    tweenscale.onComplete.addOnce(() => {
      this.revealClue(category, categoryCount);
      tweenscale.stop();
      ingenuity.currentGame.tweens.remove(tweenscale);
    })
  }

  private showGrandJPValue(): void {
    let data: any = (ingenuity.parserModel as GameParserModel).getCollectMeterParseData();
    if (this.grandJPWinMtr.getValue() != 0) {
      data?.grandPrize && (this.grandJPWinMtr.visible = true);
    }
    if (this.clueWinMtr.getValue() != 0) {
      data?.prize && (this.clueWinMtr.visible = true);
    }
    if (!(ingenuity.parserModel as GameParserModel).getClueRevealedFeatureStatus()) {
      data?.grandPrize && (this.grandJPWinMtr.visible = true);
      data?.grandPrize && this.grandJPWinMtr.setCurrencyFormattedValue(data?.grandPrize);
      data?.prize && (this.clueWinMtr.visible = true);
      data?.prize && this.clueWinMtr.setCurrencyFormattedValue(data?.prize);
    }
    this.alignClueMeters();
  }
  private alignClueMeters():void{
    if((ingenuity.parserModel as GameParserModel).getLanguage() === 'en'){
      this.clueWinMtr.x = this.clueWinMtr.json.x;
      this.grandJPWinMtr.x = this.grandJPWinMtr.json.x
      
    }else {
      this.clueWinMtr.x = this.clueWinMtr.json.localizedX;
      this.grandJPWinMtr.x = this.grandJPWinMtr.json.localizedX
    }
  }

  private showRevealedClue(): void {
    this.clueInfo = (ingenuity.parserModel as GameParserModel).getclueInfo();
    if (this.clueInfo) {
      let category: string;
      this.clueInfo.symbol51.forEach((element: string) => {
        category = 'criminal';
        this.showClue(category, element)

      });
      this.clueInfo.symbol52.forEach((element: string) => {
        category = 'location';
        this.showClue(category, element)
      })
      this.clueInfo.symbol53.forEach((element: string) => {
        category = 'weapon';
        this.showClue(category, element)
      })
    };

  }

  private showClue(category: string, categoryCount: string): void {
    this.view.getImageById(`${category}_${categoryCount}_Pin_Grey`).visible = false;
    this.view.getImageById(`${category}_${categoryCount}_Pin_Red`).visible = true;
    this.view.getImageById(`${category}Wire_${categoryCount}_Grey`).visible = false;
    this.view.getImageById(`${category}Wire_${categoryCount}_Red`).visible = true;
    this.view.getImageById(`${category}Unrevealed_${categoryCount}`).visible = false;
    this.view.getImageById(`${category}_${categoryCount}`).visible = true;
  }



  private playSound() {
    let soundObj: any;
    // if ((ingenuity.parserModel as GameParserModel).getTotalClueCount() === 15) {

    //   soundObj = { id: SoundConstantGame.ALL_CLUE_REVEALED, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD };
    // } else {

    soundObj = { id: SoundConstantGame.CLUE_REVEAL, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD };
    // }
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
  }

  // protected showGrandSuspectReveal(criminalCount: number): void {
  //   const frameGlow: SpineBase = this.view.getSpineById("frameGlow");
  //   const frameContainer: Container = this.view.getContainerByID("frameContainer");
  //   frameContainer.addChildAt(frameGlow, 0);
  //   const spinTween: ITween = ingenuity.currentGame.add.tween(frameContainer)
  //   spinTween.to({ rotation: Math.PI * 2 }, 300, Quadratic.InOut, false)
  //   spinTween.to({ rotation: 0 }, 300, Quadratic.InOut, false)
  //     .start();
  // }
  private showInvestigationRoomAfterBanner(): void {
    this.view.getContainerByID('boardMainContainer').visible = true;

  }

  private resetRoomAfterGrand(): void {
    this.suspectArray.forEach((letter: string) => {
      this.view.getImageById(`suspectFrame_${letter}`).visible = false;
    });
    gameConstants.CLUE_SECTIONS_DISABLED.forEach((name: string) => {
      this.view.getImageById(name).visible = true;
      this.view.getImageById(name).scale.set(1);
    });
    gameConstants.CLUE_SECTIONS_ENABLED_CARDS.forEach((name: string) => {
      this.view.getImageById(name).visible = false;
    });
    this.frameGlowBG.setPause(true);
    this.frameGlowBG.visible = false;
    this.grandJPWinMtr.setValue(0);
    this.grandJPWinMtr.visible = false;
    this.clueWinMtr.setValue(0)
    this.clueWinMtr.visible = false;

  }
}
